function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ModerateViewTemplate = require('./moderate-view.template');
var CatalogFooterTemplate = require('./catalog-footer.template');
var Summary = require('../summary');
var _require = require('../categories'),
  DEFAULT_PAGE_SIZE = _require.DEFAULT_PAGE_SIZE,
  normalizeOffset = _require.normalizeOffset,
  normalizePageSize = _require.normalizePageSize;
var ModerateView = /*#__PURE__*/function () {
  function ModerateView(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, ModerateView);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.listings = [];
    this.pagination = null;
    this.page = 1;
    this.page_size = DEFAULT_PAGE_SIZE;
    this.sort = 'created_at';
    this.direction = 'desc';
    this.loading = false;
    this.denied = false;
    this.request_token = 0;
    this.last_checked_index = -1;
    this.busy = false;
  }
  return _createClass(ModerateView, [{
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) {
        this.container = container;
      }
      if (!this.container) {
        return;
      }
      this.app.browser.replaceElementContentBySelector(ModerateViewTemplate({
        loading: this.loading,
        denied: this.denied
      }), this.container);
      if (this.denied) {
        return;
      }
      this.renderTable();
      this.attachToolbarEvents();
    }
  }, {
    key: "reload",
    value: function reload() {
      return this.loadPage({
        page: this.page,
        scroll: false
      });
    }
  }, {
    key: "show",
    value: function () {
      var _show = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.denied = false;
              this.render();
              return _context.a(2, this.loadPage({
                page: 1,
                scroll: false
              }));
          }
        }, _callee, this);
      }));
      function show() {
        return _show.apply(this, arguments);
      }
      return show;
    }()
  }, {
    key: "loadPendingPage",
    value: function loadPendingPage() {
      var _this = this;
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$offset = _ref.offset,
        offset = _ref$offset === void 0 ? 0 : _ref$offset,
        _ref$page_size = _ref.page_size,
        page_size = _ref$page_size === void 0 ? this.page_size : _ref$page_size,
        _ref$sort = _ref.sort,
        sort = _ref$sort === void 0 ? this.sort : _ref$sort,
        _ref$direction = _ref.direction,
        direction = _ref$direction === void 0 ? this.direction : _ref$direction;
      return new Promise(function (resolve, reject) {
        var _this$app;
        var peerKey = _this.mod.store_public_key;
        if (!peerKey || !((_this$app = _this.app) !== null && _this$app !== void 0 && (_this$app = _this$app.network) !== null && _this$app !== void 0 && _this$app.sendRequestAsTransaction)) {
          reject(new Error('Store peer unavailable'));
          return;
        }
        _this.app.network.sendRequestAsTransaction('load-pending-listings', {
          module: 'Store',
          offset: normalizeOffset(offset),
          page_size: normalizePageSize(page_size),
          sort: sort,
          direction: direction
        }, function (response) {
          if (!response || response.err || Number(response.authorized) !== 1) {
            reject(new Error((response === null || response === void 0 ? void 0 : response.err) || 'Unauthorized access'));
            return;
          }
          if (!Array.isArray(response.listings)) {
            reject(new Error('Invalid load-pending-listings response'));
            return;
          }
          resolve(response);
        }, peerKey, true);
      });
    }
  }, {
    key: "sendModerateAction",
    value: function sendModerateAction(action, signatures) {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        var _this2$app;
        var peerKey = _this2.mod.store_public_key;
        if (!peerKey || !((_this2$app = _this2.app) !== null && _this2$app !== void 0 && (_this2$app = _this2$app.network) !== null && _this2$app !== void 0 && _this2$app.sendRequestAsTransaction)) {
          reject(new Error('Store peer unavailable'));
          return;
        }
        _this2.app.network.sendRequestAsTransaction('moderate-listings', {
          module: 'Store',
          action: action,
          signatures: signatures
        }, function (response) {
          if (!response || response.err || Number(response.authorized) !== 1) {
            reject(new Error((response === null || response === void 0 ? void 0 : response.err) || 'Unauthorized access'));
            return;
          }
          resolve(response);
        }, peerKey, true);
      });
    }
  }, {
    key: "loadPage",
    value: function () {
      var _loadPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this3 = this;
        var _ref2,
          _ref2$page,
          page,
          _ref2$sort,
          sort,
          _ref2$direction,
          direction,
          _ref2$scroll,
          scroll,
          next_page,
          next_sort,
          next_dir,
          offset,
          token,
          _this$pagination,
          result,
          unauthorized,
          _document$querySelect,
          _args2 = arguments,
          _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _ref2 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, _ref2$page = _ref2.page, page = _ref2$page === void 0 ? this.page : _ref2$page, _ref2$sort = _ref2.sort, sort = _ref2$sort === void 0 ? this.sort : _ref2$sort, _ref2$direction = _ref2.direction, direction = _ref2$direction === void 0 ? this.direction : _ref2$direction, _ref2$scroll = _ref2.scroll, scroll = _ref2$scroll === void 0 ? false : _ref2$scroll;
              next_page = Math.max(1, Number(page) || 1);
              next_sort = String(sort || 'created_at');
              next_dir = String(direction || '').toLowerCase() === 'asc' ? 'asc' : 'desc';
              offset = (next_page - 1) * this.page_size;
              token = ++this.request_token;
              this.page = next_page;
              this.sort = next_sort;
              this.direction = next_dir;
              this.loading = true;
              this.denied = false;
              this.showLoading();
              _context2.p = 1;
              _context2.n = 2;
              return this.loadPendingPage({
                offset: offset,
                page_size: this.page_size,
                sort: next_sort,
                direction: next_dir
              });
            case 2:
              result = _context2.v;
              if (!(token !== this.request_token)) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2);
            case 3:
              this.listings = (result.listings || []).map(function (data) {
                return new Summary(_this3.app, _this3.mod, data);
              }).filter(function (summary) {
                return !!summary.listing_signature;
              });
              this.pagination = result.pagination || null;
              this.page = ((_this$pagination = this.pagination) === null || _this$pagination === void 0 ? void 0 : _this$pagination.page) || next_page;
              this.sort = result.sort || next_sort;
              this.direction = result.direction || next_dir;
              this.syncPendingCount(result.pending, 1);
              _context2.n = 6;
              break;
            case 4:
              _context2.p = 4;
              _t = _context2.v;
              if (!(token !== this.request_token)) {
                _context2.n = 5;
                break;
              }
              return _context2.a(2);
            case 5:
              unauthorized = /unauthor/i.test(String((_t === null || _t === void 0 ? void 0 : _t.message) || ''));
              this.denied = unauthorized;
              this.listings = [];
              this.pagination = null;
              if (unauthorized) {
                this.syncPendingCount(0, 0);
              }
              console.warn('Store: load-pending-listings failed', (_t === null || _t === void 0 ? void 0 : _t.message) || _t);
            case 6:
              if (!(token !== this.request_token)) {
                _context2.n = 7;
                break;
              }
              return _context2.a(2);
            case 7:
              this.loading = false;
              this.render();
              if (scroll) {
                (_document$querySelect = document.querySelector("".concat(this.container, " .moderation-page"))) === null || _document$querySelect === void 0 || _document$querySelect.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start'
                });
              }
            case 8:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 4]]);
      }));
      function loadPage() {
        return _loadPage.apply(this, arguments);
      }
      return loadPage;
    }()
  }, {
    key: "syncPendingCount",
    value: function syncPendingCount(pending) {
      var _this$mod$applyStoreM, _this$mod;
      var authorized = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      (_this$mod$applyStoreM = (_this$mod = this.mod).applyStoreModerationResponse) === null || _this$mod$applyStoreM === void 0 || _this$mod$applyStoreM.call(_this$mod, {
        authorized: Number(authorized) === 1 ? 1 : 0,
        pending: Math.max(0, Number(pending) || 0)
      });
    }
  }, {
    key: "showLoading",
    value: function showLoading() {
      var status = document.querySelector("".concat(this.container, " [data-storefront-status]"));
      if (!status) {
        this.render();
        return;
      }
      status.hidden = false;
      status.innerHTML = "<div class=\"saito-spinner\" aria-hidden=\"true\"></div><p>Loading listings\u2026</p>";
    }
  }, {
    key: "renderTable",
    value: function renderTable() {
      var _this$pagination$tota,
        _this$pagination2,
        _this4 = this;
      var host = document.querySelector("".concat(this.container, " [data-listings-table]"));
      var footer = document.querySelector("".concat(this.container, " [data-catalog-footer]"));
      if (!host) {
        return;
      }
      var status = document.querySelector("".concat(this.container, " [data-storefront-status]"));
      if (status) {
        status.hidden = true;
        status.innerHTML = '';
      }
      var total = Number((_this$pagination$tota = (_this$pagination2 = this.pagination) === null || _this$pagination2 === void 0 ? void 0 : _this$pagination2.total) !== null && _this$pagination$tota !== void 0 ? _this$pagination$tota : this.listings.length);
      if (!total) {
        host.innerHTML = '<div class="storefront-empty"><p class="body">No listings awaiting moderation.</p></div>';
        if (footer) {
          footer.hidden = true;
          footer.innerHTML = '';
        }
        this.syncActionButtons();
        return;
      }
      host.innerHTML = ModerateViewTemplate.table({
        listings: this.listings,
        sort: this.sort,
        direction: this.direction
      });
      this.attachTableEvents();
      if (footer) {
        footer.hidden = false;
        footer.innerHTML = CatalogFooterTemplate({
          pagination: this.pagination,
          empty: false
        });
        CatalogFooterTemplate.attachCatalogFooterEvents(footer, {
          page: this.page,
          pagination: this.pagination,
          onPage: function onPage(next) {
            void _this4.loadPage({
              page: next,
              scroll: true
            });
          }
        });
      }
      this.syncActionButtons();
    }
  }, {
    key: "selectedSignatures",
    value: function selectedSignatures() {
      var root = document.querySelector(this.container);
      if (!root) {
        return [];
      }
      return Array.from(root.querySelectorAll('tbody [data-select-row]:checked')).map(function (input) {
        var _input$closest;
        return ((_input$closest = input.closest('tr')) === null || _input$closest === void 0 ? void 0 : _input$closest.getAttribute('data-signature')) || '';
      }).filter(Boolean);
    }
  }, {
    key: "syncActionButtons",
    value: function syncActionButtons() {
      var _this5 = this;
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      var selected = this.selectedSignatures().length;
      root.querySelectorAll('[data-action="approve"], [data-action="reject"]').forEach(function (btn) {
        btn.disabled = selected === 0 || _this5.busy;
      });
      var all = root.querySelectorAll('tbody [data-select-row]');
      var checked = root.querySelectorAll('tbody [data-select-row]:checked');
      var header = root.querySelector('[data-select-all]');
      if (header) {
        header.checked = all.length > 0 && checked.length === all.length;
        header.indeterminate = checked.length > 0 && checked.length < all.length;
      }
    }
  }, {
    key: "attachToolbarEvents",
    value: function attachToolbarEvents() {
      var _root$querySelector,
        _this6 = this,
        _root$querySelector2;
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      (_root$querySelector = root.querySelector('[data-action="approve"]')) === null || _root$querySelector === void 0 || _root$querySelector.addEventListener('click', function (e) {
        e.preventDefault();
        void _this6.moderateSelected('approve');
      });
      (_root$querySelector2 = root.querySelector('[data-action="reject"]')) === null || _root$querySelector2 === void 0 || _root$querySelector2.addEventListener('click', function (e) {
        e.preventDefault();
        void _this6.moderateSelected('reject');
      });
    }
  }, {
    key: "attachTableEvents",
    value: function attachTableEvents() {
      var _this7 = this;
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      root.querySelectorAll('th[data-sort]').forEach(function (th) {
        th.onclick = function (e) {
          e.preventDefault();
          var column = th.getAttribute('data-sort') || 'created_at';
          var nextDir = _this7.sort === column && _this7.direction === 'asc' ? 'desc' : 'asc';
          void _this7.loadPage({
            page: 1,
            sort: column,
            direction: nextDir,
            scroll: false
          });
        };
      });
      var rows = Array.from(root.querySelectorAll('tbody tr[data-signature]'));
      var header = root.querySelector('[data-select-all]');
      if (header) {
        header.onchange = function () {
          rows.forEach(function (row) {
            var box = row.querySelector('[data-select-row]');
            if (box) {
              box.checked = header.checked;
            }
          });
          _this7.last_checked_index = -1;
          _this7.syncActionButtons();
        };
      }
      rows.forEach(function (row, index) {
        var _row$querySelector, _row$querySelector2, _row$querySelector3;
        var box = row.querySelector('[data-select-row]');
        if (box) {
          box.addEventListener('click', function (e) {
            e.stopPropagation();
            if (e.shiftKey && _this7.last_checked_index >= 0) {
              var from = Math.min(_this7.last_checked_index, index);
              var to = Math.max(_this7.last_checked_index, index);
              var check = box.checked;
              for (var i = from; i <= to; i++) {
                var _rows$i;
                var other = (_rows$i = rows[i]) === null || _rows$i === void 0 ? void 0 : _rows$i.querySelector('[data-select-row]');
                if (other) {
                  other.checked = check;
                }
              }
            }
            _this7.last_checked_index = index;
            _this7.syncActionButtons();
          });
          box.addEventListener('change', function () {
            _this7.syncActionButtons();
          });
        }
        (_row$querySelector = row.querySelector('[data-action="message-seller"]')) === null || _row$querySelector === void 0 || _row$querySelector.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          _this7.openChat(e.currentTarget.getAttribute('data-public-key') || '');
        });
        (_row$querySelector2 = row.querySelector('[data-action="preview-listing"]')) === null || _row$querySelector2 === void 0 || _row$querySelector2.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          _this7.openPreview(row.getAttribute('data-signature') || '');
        });
        (_row$querySelector3 = row.querySelector('[data-action="inspect-listing"]')) === null || _row$querySelector3 === void 0 || _row$querySelector3.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          _this7.openInspect(row.getAttribute('data-signature') || '');
        });
      });
    }
  }, {
    key: "openChat",
    value: function openChat() {
      var _this$app$modules$ret, _this$app$modules;
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var key = String(publicKey || '').trim();
      if (!key) {
        return;
      }
      (_this$app$modules$ret = (_this$app$modules = this.app.modules).returnFirstRespondTo) === null || _this$app$modules$ret === void 0 || _this$app$modules$ret.call(_this$app$modules, 'chat-manager');
      this.app.connection.emit('open-chat-with', {
        key: key,
        activate: true
      });
    }
  }, {
    key: "openPreview",
    value: function openPreview() {
      var _this$mod$main, _this$mod$main2, _detail$open;
      var signature = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var summary = this.listings.find(function (item) {
        return String(item.listing_signature || '') === String(signature || '');
      });
      if (!summary) {
        return;
      }
      var detail = ((_this$mod$main = this.mod.main) === null || _this$mod$main === void 0 ? void 0 : _this$mod$main.listing_detail) || ((_this$mod$main2 = this.mod.main) === null || _this$mod$main2 === void 0 ? void 0 : _this$mod$main2.product_overlay);
      detail === null || detail === void 0 || (_detail$open = detail.open) === null || _detail$open === void 0 || _detail$open.call(detail, summary, {
        preview: true
      });
    }
  }, {
    key: "openInspect",
    value: function openInspect() {
      var _this$mod$main3, _this$mod$main3$open;
      var signature = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var summary = this.listings.find(function (item) {
        return String(item.listing_signature || '') === String(signature || '');
      });
      if (!summary) {
        return;
      }
      (_this$mod$main3 = this.mod.main) === null || _this$mod$main3 === void 0 || (_this$mod$main3 = _this$mod$main3.listing_inspect) === null || _this$mod$main3 === void 0 || (_this$mod$main3$open = _this$mod$main3.open) === null || _this$mod$main3$open === void 0 || _this$mod$main3$open.call(_this$mod$main3, summary);
    }
  }, {
    key: "moderateSelected",
    value: function () {
      var _moderateSelected = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(action) {
        var signatures, _ref3, _result$pending, _this$pagination3, result, failed, page, remaining, lastPage, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              signatures = this.selectedSignatures();
              if (!(!signatures.length || this.busy)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              this.busy = true;
              this.syncActionButtons();
              _context3.p = 2;
              _context3.n = 3;
              return this.sendModerateAction(action, signatures);
            case 3:
              result = _context3.v;
              this.syncPendingCount(result.pending, 1);
              failed = (result.results || []).filter(function (row) {
                return !row.ok;
              });
              if (failed.length && typeof siteMessage === 'function') {
                siteMessage(failed.length === signatures.length ? 'Those listings are no longer pending.' : 'Some listings were already moderated.', 4000);
              }
              page = this.page;
              remaining = Number((_ref3 = (_result$pending = result.pending) !== null && _result$pending !== void 0 ? _result$pending : (_this$pagination3 = this.pagination) === null || _this$pagination3 === void 0 ? void 0 : _this$pagination3.total) !== null && _ref3 !== void 0 ? _ref3 : 0);
              lastPage = Math.max(1, Math.ceil(remaining / this.page_size) || 1);
              if (page > lastPage) {
                page = lastPage;
              }
              _context3.n = 4;
              return this.loadPage({
                page: page,
                scroll: false
              });
            case 4:
              _context3.n = 6;
              break;
            case 5:
              _context3.p = 5;
              _t2 = _context3.v;
              console.warn('Store: moderate-listings failed', (_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || _t2);
              if (typeof siteMessage === 'function') {
                siteMessage((_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || 'Unable to update listings.', 4000);
              }
              if (/unauthor/i.test(String((_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || ''))) {
                this.denied = true;
                this.syncPendingCount(0, 0);
                this.render();
              }
            case 6:
              _context3.p = 6;
              this.busy = false;
              this.syncActionButtons();
              return _context3.f(6);
            case 7:
              return _context3.a(2);
          }
        }, _callee3, this, [[2, 5, 6, 7]]);
      }));
      function moderateSelected(_x) {
        return _moderateSelected.apply(this, arguments);
      }
      return moderateSelected;
    }()
  }]);
}();
module.exports = ModerateView;